import axios from "axios";
import React, { useEffect, useState } from "react";

const SectionData = ({ sec }) => {
  const urlPrefix = process.env.REACT_APP_URL_STATION_MAPPING;

  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const head = ["SR.", "BLOCK", "DIRECTION", "TIME", "TRAIN"];
  const head1 = ["SR.", "TRAIN", "SPEED"];
  const head2 = ["SR.", "SECTION", "GRADIENT", "DIRECTION", "LENGTH"];

  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const fetchstation = async () => {
    try {
      const response = await axios.get(
        `${urlPrefix}section-details?section_name=${sec}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.data);
      } else if (response.status === "200") {
        setData([]);
      }
    } catch (err) {
      console.error("Failed to fetch stations", err);
      setError(true);
    }
  };

  useEffect(() => {
    fetchstation();
  }, [sec]);

  return (
    <div className="">
      <h5 className="p-2 rounded  card-header-soft">Section Data</h5>
      <div className="row" style={{ fontSize: "13px" }}>
        {data && (
          <div className="col-md-4 mt-3  ">
            <div className="shadow-sm mb-4 glass-card">
              <div className="px-4 py-3 card-header-soft ">
                <h6 className="mb-0">{data.section_name}</h6>
              </div>

              <div className="p-3 small">
                {[
                  ["SECTION", data.section_name],
                  ["NO OF STATION", data.no_of_stations],
                  ["LENGTH ", data.length_km],

                  ["SIGNAL", data.signalling],
                  ["INTERLOCK TYPE", data.interlocking_type],
                  ["SYSTEM OF WORKING", data.system_of_working],
                ].map(([label, value], idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between mb-2"
                    style={{ color: "#6d5646" }}
                  >
                    <span className="text-muted">{label}</span>
                    <strong>{value}</strong>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* ///////////////////////////////////////////////////////////////////// */}
        {data.critical_block_sections && (
          <div className="col-md-4 mt-3">
            <div
              className="shadow-sm mb-4 glass-card"
              style={{
                overflow: "hidden",
              }}
            >
              <div
                className="card-header-soft"
                style={{
                  clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 100%)",
                }}
              >
                <strong>CRITICAL BLOCK SECTION</strong>
              </div>

              <div className="p-2 fw-semibold table-responsive">
                <table className="text-start">
                  <thead>
                    <tr>
                      {head.map((o, i) => (
                        <th key={i}>{o}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {data.critical_block_sections?.map((o, i) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{o.block}</td>
                        <td>{o.direction}</td> <td>{o.time}</td>
                        <td>{o.train}</td>{" "}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* ///////////////////////////////////////////////////// */}
        {data.ruling_gradient && (
          <div className="col-md-4 mt-3">
            <div
              className="shadow-sm mb-4 glass-card"
              style={{
                overflow: "hidden",
              }}
            >
              <div
                className="card-header-soft"
                style={{
                  clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 100%)",
                }}
              >
                <strong>RULLING GRADIENT</strong>
              </div>

              <div className="p-2 fw-semibold table-responsive">
                <table className="text-start">
                  <thead>
                    <tr>
                      {head2.map((o, i) => (
                        <th key={i}>{o}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {data.ruling_gradient?.map((o, i) => (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{o.section}</td>
                        <td>{o.gradient}</td> <td>{o.direction}</td>
                        <td>{o.length_km}</td>{" "}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* ////////////////////////////////////////// */}
      </div>
      <div className="row" style={{ fontSize: "12px" }}>
        {data.max_permissible_speed && (
          <div className="col-md-4 mt-3">
            <div className="shadow-sm mb-4">
              <div className="card-header-soft">
                <strong> MAX PERMISSIBLE SPEED </strong>
              </div>

              <div className=" m-1 mb-2 p-0 glass-card table-responsive">
                <table className="text-start">
                  <thead>
                    <tr>
                      {head1.map((o, i) => (
                        <th key={i}>{o}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {data.max_permissible_speed?.map((o, i) => (
                      <tr>
                        <td>{i + 1}</td> <td>{o.train_type}</td>
                        <td>{o.speed}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {data.sectional_running_time && (
          <div className="col-md-4 mt-3">
            <div className="shadow-sm mb-4">
              <div className="card-header-soft">
                <strong>SECTIONAL RUNNING TIME</strong>
              </div>

              <div className=" m-1 mb-2 p-0 glass-card table-responsive">
                <table className="text-start">
                  <thead>
                    <tr>
                      {head1.map((o, i) => (
                        <th key={i}>{o}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {data?.sectional_running_time &&
                      Object.entries(data.sectional_running_time).map(
                        (o, i) => (
                          <tr>
                            <td>{i + 1}</td> <td>{o[0]}</td>
                            <td> {o[1]}</td>
                          </tr>
                        ),
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {data.station_class_summary && (
          <div className="col-md-4 mt-3">
            <div className="shadow-sm mb-4">
              <div className="card-header-soft">
                <strong>STATION CLASS SUMMARY </strong>
              </div>

              <div className=" m-1 mb-2 p-0 glass-card table-responsive">
                <table className="text-start">
                  <thead>
                    <tr>
                      {head1.map((o, i) => (
                        <th key={i}>{o}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {data?.station_class_summary &&
                      Object.entries(data.station_class_summary).map((o, i) => (
                        <tr>
                          <td>{i + 1}</td> <td>{o[0]}</td>
                          <td> {o[1]}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionData;
